import { Container, Paper, Typography } from "@mui/material";
import BatchUploadForm from "../components/batch-upload/BatchUploadForm";

const BatchPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper
        elevation={3}
        sx={{ p: 4 }}
        className="animate__animated animate__fadeIn animate__delay-05s"
      >
        <Typography variant="h4" sx={{ mb: 4 }}>
          Batch Configuration CSV Upload
        </Typography>
        <BatchUploadForm />
      </Paper>
    </Container>
  );
};

export default BatchPage;
